import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import { booksActions } from '../../../store/books';
import { Panel, PanelHeader } from '../../../components/admin/panel/panel';
import { breadcrumb } from '../../../helpers/page-admin';
import 'react-table/react-table.css';

class Books extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formFiles: [],
        };

        this.category = this.props.match.params.c;
        this.subCategory = this.props.match.params.s;

        this.defaultSorted = [
            {
                //id: "bookId",
                //desc: true
            }
        ];
        this.tableColumns = [
            {
                Header: "정보",
                columns: [
                    {
                        Header: "ID",
                        accessor: "bookId",
                        maxWidth: 100,
                        className: 'text-center',
                    },
                    {
                        Header: "제목",
                        accessor: 'name',
                    },
                    {
                        Header: "저자",
                        accessor: 'author',
                    },
                    {
                        Header: "출판사",
                        accessor: 'publish',
                    },
                ]
            },
            {
                Header: '청구',
                columns: [
                    {
                        Header: "청구번호",
                        accessor: 'reqno',
                    },
                ]
            },
            {
                filterable: false,
                Header: '',
                accessor: 'bookId',
                Cell: row => (
                    <div className="text-center">
                        <button onClick={event => { if (window.confirm('정말로 삭제하시겠습니까?')) this.onClickDelete(event, row.value) }} className="btn btn-grey btn-xs rounded-0 m-r-5 m-t-minus-5">삭제</button>
                    </div>
                ),
                maxWidth: 120
            }
        ]
    }

    componentDidMount() {
        this.props.getBooks(this.category, this.subCategory);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.books !== nextProps.books) {
            return { books: nextProps.books };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        const mc = this.props.match.params.c;
        const ms = this.props.match.params.s;
        if (this.category !== mc || this.subCategory !== ms) {
            this.category = mc;
            this.subCategory = ms;
            this.props.getBooks(mc, ms);
        }
    }

    onChange = (event) => {
        const name = event.target.name.split('_')[1];
        const id = event.target.name.split('_')[2];
        this.props.checkBoard(name, id);
    }

    async onClickCreate(event) {
        event.preventDefault();
        let file = event.target.files[0] ? event.target.files[0] : null;
        if (file === null) return;

        let { formFiles } = this.state;
        formFiles[0] = file;
        this.setState({ formFiles: formFiles });

        await this.props.postBook(this.state);
        await this.props.history.push(`/admin/books/${this.category}/${this.subCategory}`);
    }

    onClickUpdate = (event, book) => {
        event.preventDefault();
        this.props.history.push({
            pathname: `/admin/books/update/${book.bookId}`,
            state: { panelTitle: this.panelTitle, ...book }
        });
    }

    onClickDelete = (event, id) => {
        event.preventDefault();
        if (id) this.props.deleteBook(id);
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <button onClick={() => { this.upload.click() }} className="btn btn-danger btn-sm"><i className="fa fa-plus"></i> 신규등록</button>
                    <input id="myInput" type="file" ref={(ref) => this.upload = ref} style={{ display: 'none' }} onChange={this.onClickCreate.bind(this)} />
                </div>
                <Panel>
                    <PanelHeader>{breadcrumb(this.props).title} 리스트</PanelHeader>
                    <ReactTable className="-highlight"
                        filterable
                        data={this.state.books}
                        columns={this.tableColumns}
                        defaultPageSize={10}
                        defaultSorted={this.defaultSorted}
                        loading={this.props.isLoading}
                        previousText='이전' nextText='다음' />
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => state.books,
    dispatch => bindActionCreators({ ...booksActions }, dispatch)
)(withRouter(Books));


// WEBPACK FOOTER //
// ./src/pages/admin/books/index.js